import bannerImg from "../assets/banner.png"
import "./styles.css"

const Banner = () => {
    // const handleClick = () => {
    // }
    return (
        <div className="container-banner">
            <div className="inner-container">
                <div className="text-container">
                    <h1 className="headingMain">Welcome to Intern Crafters</h1>
                    At Intern Crafters, we are committed to supporting college students by providing opportunities for growth, learning and career development. Our platform offers a combination of internships and free courses designed to give students the skills and experience they need to succeed in today's competitive business world.

                </div>
                {/* <button className="get-started-btn" onClick={handleClick}>Get Started</button> */}
            </div>
            <div className="image-container">
                <img src={bannerImg} alt="#" />
            </div>
        </div>
    )
}

export default Banner